import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["colspan"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mt-4 font-weight-bold" }, "Kehtivad broneeringud", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "font-weight-bold" }, "Üldkasuliku töö tundide asendamine", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "font-weight-bold" }, "Lõppenud broneeringud", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("b", null, "ÜKT tähtaeg:", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("b", null, "Aega lõpuni:", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("b", null, "Määratud:", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("b", null, "Sooritatud:", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("b", null, "Sooritamata:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BroneeringuTabel = _resolveComponent("BroneeringuTabel")!
  const _component_UKTTundideAsendamiseTabel = _resolveComponent("UKTTundideAsendamiseTabel")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_data_iterator = _resolveComponent("v-data-iterator")!
  const _component_AjakavaTabel = _resolveComponent("AjakavaTabel")!
  const _component_AjakavaRidaTabel = _resolveComponent("AjakavaRidaTabel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { class: "px-5" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_data_table, {
              class: "mt-4 rounded elevation-3",
              expanded: _ctx.tabel.laiendatud,
              headers: _ctx.tabel.paised,
              items: _ctx.elemendid,
              "items-per-page": _ctx.tabel.lehePikkus,
              loading: _ctx.laeb,
              "show-expand": "",
              "fixed-header": "",
              "single-expand": "",
              "item-key": "id"
            }, {
              [`item.tahtaegKp`]: _withCtx(({ value }) => [
                _createTextVNode(_toDisplayString(_ctx.formateeriKuupaev(value)), 1)
              ]),
              "expanded-row": _withCtx(({ columns, item }) => [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", {
                    colspan: columns.length
                  }, [
                    _hoisted_2,
                    _createVNode(_component_BroneeringuTabel, {
                      elemendid: (item.kehtivadBroneeringud as any),
                      aluseId: _ctx.aluseId,
                      broneeringuId: _ctx.broneeringuId,
                      ajakavaId: _ctx.ajakavaId
                    }, null, 8, ["elemendid", "aluseId", "broneeringuId", "ajakavaId"]),
                    _hoisted_3,
                    _createVNode(_component_UKTTundideAsendamiseTabel, {
                      elemendid: (item.tundideAsendamised as any)
                    }, null, 8, ["elemendid"]),
                    _hoisted_4,
                    _createVNode(_component_BroneeringuTabel, {
                      elemendid: (item.loppenudBroneeringud as any),
                      aluseId: _ctx.aluseId,
                      broneeringuId: _ctx.broneeringuId,
                      ajakavaId: _ctx.ajakavaId
                    }, null, 8, ["elemendid", "aluseId", "broneeringuId", "ajakavaId"])
                  ], 8, _hoisted_1)
                ])
              ]),
              _: 2
            }, 1032, ["expanded", "headers", "items", "items-per-page", "loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { class: "d-lg-none d-none" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { class: "px-5" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              color: "primary",
              title: "Arvel olemise alused"
            }, {
              default: _withCtx(() => [
                (_ctx.laeb)
                  ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                      key: 0,
                      type: "article"
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_data_iterator, {
                  items: _ctx.annaAlused,
                  "item-value": "lahendiNr"
                }, {
                  default: _withCtx(({ items }) => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (item) => {
                          return (_openBlock(), _createBlock(_component_v_col, {
                            class: "w-100",
                            cols: "auto",
                            key: item.raw.lahendiNr
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, { class: "mx-auto" }, {
                                title: _withCtx(() => [
                                  _createTextVNode(" Lahendi nr.: " + _toDisplayString(item.raw.lahendiNr), 1)
                                ]),
                                prepend: _withCtx(() => [
                                  (_ctx.aluseId)
                                    ? (_openBlock(), _createBlock(_component_v_btn, {
                                        key: 0,
                                        onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$router.push({ name: 'uldkasulik_Too' });}),
                                        icon: "mdi-chevron-left"
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                append: _withCtx(() => [
                                  (!_ctx.aluseId)
                                    ? (_openBlock(), _createBlock(_component_v_btn, {
                                        key: 0,
                                        onClick: ($event: any) => {_ctx.$router.replace({ name: 'uldkasulik_Too', params: { ajakavaRidaId: [item.raw.id] } });},
                                        icon: "mdi-chevron-right"
                                      }, null, 8, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_expansion_panels, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_expansion_panel, {
                                        title: item.raw.arvelOlemiseAlus
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_expansion_panel_text, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list, {
                                                lines: false,
                                                density: "compact"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_list_item, {
                                                    title: _ctx.formateeriKuupaev(item.raw.tahtaegKp)
                                                  }, {
                                                    title: _withCtx(({ title }) => [
                                                      _hoisted_5,
                                                      _createTextVNode(" " + _toDisplayString(title), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["title"]),
                                                  _createVNode(_component_v_list_item, {
                                                    title: item.raw.aegaLopuni
                                                  }, {
                                                    title: _withCtx(({ title }) => [
                                                      _hoisted_6,
                                                      _createTextVNode(" " + _toDisplayString(title), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["title"]),
                                                  _createVNode(_component_v_list_item, {
                                                    title: item.raw.maaratud
                                                  }, {
                                                    title: _withCtx(({ title }) => [
                                                      _hoisted_7,
                                                      _createTextVNode(" " + _toDisplayString(title), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["title"]),
                                                  _createVNode(_component_v_list_item, {
                                                    title: item.raw.sooritatud
                                                  }, {
                                                    title: _withCtx(({ title }) => [
                                                      _hoisted_8,
                                                      _createTextVNode(" " + _toDisplayString(title), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["title"]),
                                                  _createVNode(_component_v_list_item, {
                                                    title: item.raw.sooritamata
                                                  }, {
                                                    title: _withCtx(({ title }) => [
                                                      _hoisted_9,
                                                      _createTextVNode(" " + _toDisplayString(title), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["title"])
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["title"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }, 8, ["items"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.elemendidOlemas(_ctx.annaKehtivadBroneeringud) && _ctx.aluseId)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 0,
          class: "d-lg-none d-none"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { class: "px-5" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  color: "primary",
                  title: "Kehtivad broneeringud"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_BroneeringuTabel, {
                      aluseId: _ctx.aluseId,
                      broneeringuId: _ctx.broneeringuId,
                      ajakavaId: _ctx.ajakavaId,
                      elemendid: _ctx.annaKehtivadBroneeringud
                    }, null, 8, ["aluseId", "broneeringuId", "ajakavaId", "elemendid"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.broneeringuId)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.annaKehtivadBroneeringud, (element, i) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
            _createVNode(_component_v_row, { class: "d-lg-none d-none" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { class: "px-5" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      color: "primary",
                      title: "Ajakavad"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_AjakavaTabel, {
                          aluseId: _ctx.aluseId,
                          broneeringuId: _ctx.broneeringuId,
                          ajakavaId: _ctx.ajakavaId,
                          class: "d-lg-none",
                          elemendid: _ctx.annaAjakavad(element)
                        }, null, 8, ["aluseId", "broneeringuId", "ajakavaId", "elemendid"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024),
            (_ctx.ajakavaId)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.annaAjakavad(element), (ajakava, i) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                    (ajakava.ajakavaList)
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 0,
                          class: "d-lg-none d-none"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { class: "px-5" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card, {
                                  color: "primary",
                                  title: "Ajakava"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_AjakavaRidaTabel, {
                                      aluseId: _ctx.aluseId,
                                      broneeringuId: _ctx.broneeringuId,
                                      ajakavaId: _ctx.ajakavaId,
                                      class: "d-lg-none",
                                      elemendid: ajakava.ajakavaList
                                    }, null, 8, ["aluseId", "broneeringuId", "ajakavaId", "elemendid"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      : _createCommentVNode("", true),
    (_ctx.elemendidOlemas(_ctx.annaTundideAsendamised) && _ctx.aluseId && !_ctx.broneeringuId)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 2,
          class: "d-lg-none d-none"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { class: "px-5" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  color: "primary",
                  title: "Üldkasuliku töö tundide asendamine"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_UKTTundideAsendamiseTabel, {
                      elemendid: (_ctx.annaTundideAsendamised as any)
                    }, null, 8, ["elemendid"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.elemendidOlemas(_ctx.annaLoppenudBroneeringud) && _ctx.aluseId)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 3,
          class: "d-lg-none d-none"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { class: "px-5" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  color: "primary",
                  title: "Lõppenud broneeringud"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_BroneeringuTabel, {
                      aluseId: _ctx.aluseId,
                      broneeringuId: _ctx.broneeringuId,
                      ajakavaId: _ctx.ajakavaId,
                      elemendid: _ctx.annaLoppenudBroneeringud
                    }, null, 8, ["aluseId", "broneeringuId", "ajakavaId", "elemendid"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.broneeringuId)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(_ctx.annaLoppenudBroneeringud, (element, i) => {
          return (_openBlock(), _createBlock(_component_v_row, {
            class: "d-lg-none d-none",
            key: i
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "px-5" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    color: "primary",
                    title: "Ajakavad"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_AjakavaTabel, {
                        aluseId: _ctx.aluseId,
                        broneeringuId: _ctx.broneeringuId,
                        ajakavaId: _ctx.ajakavaId,
                        class: "d-lg-none",
                        elemendid: _ctx.annaAjakavad(element)
                      }, null, 8, ["aluseId", "broneeringuId", "ajakavaId", "elemendid"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024))
        }), 128))
      : _createCommentVNode("", true)
  ], 64))
}